export default __webpack_public_path__ + "static/media/mode-16.ce7a3839.svg";